import React from 'react';

import Helmet from 'react-helmet';

import { Box, BuilderAuthCard, BuilderStyledButton, BuilderSubtitle, BuilderTitle } from 'pages/auth/style';
import { ButtonComponent } from 'components';
import { COLORS } from 'theme/constants';
import useIsMobile from 'hooks/useIsMobile';

import { BuilderContactUsFooter } from '../BuilderContactUsFooter';

import { ReactComponent as CozmosSVGWhite } from 'assets/img/cozmos-logo.svg';

// TODO: de-duplicate with BuilderSignUp

interface BuilderAuthMessageProps {
  tabTitle: string;
  title: string;
  text?: React.ReactElement | string;
  buttonText?: string;
  onBack?: () => void;
  onButtonClick?: () => void;
  disabled?: boolean;
  buttonIcon?: React.FC;
  buttonVariant?: 'text' | 'outlined' | 'contained' | undefined;
}

export const BuilderAuthMessage = ({
  tabTitle,
  title,
  text,
  buttonText,
  onBack,
  onButtonClick,
  disabled,
  buttonIcon,
  buttonVariant,
}: BuilderAuthMessageProps) => {
  const isMobile = useIsMobile();
  return (
    <BuilderAuthCard mobile={isMobile}>
      <Helmet title={tabTitle} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: isMobile ? 'start' : 'center',
          gap: '20px',
          flexGrow: 1,
          maxWidth: '440px',
        }}
      >
        {isMobile && <CozmosSVGWhite style={{ width: '120px', height: '32px' }} />}
        {onBack &&
        <ButtonComponent
          color="primary"
          variant="text"
          className="no-padding"
          text="< Back"
          onClick={onBack}
          style={{ color: COLORS.builderBrandColor }}
        />}
        <div style={{ flexGrow: 1 }} />
        {title && <BuilderTitle>{title}</BuilderTitle>}
        {text && <BuilderSubtitle>{text}</BuilderSubtitle>}
        {buttonText && onButtonClick && (
          <Box>
            <BuilderStyledButton
              fullWidth
              color="primary"
              text={buttonText}
              onClick={onButtonClick}
              disabled={disabled}
              Icon={buttonIcon}
              variant={buttonVariant ?? 'contained'}
            />
          </Box>
        )}
        <div style={{ flexGrow: 3 }} />
        <BuilderContactUsFooter />
        <div style={{ flexGrow: 0.05 }} />
      </div>
    </BuilderAuthCard>
  );
};
